import { ContainerHeading } from './ContainerHeading';

export default ContainerHeading;
